import { render, staticRenderFns } from "./HtmlBlockView.vue?vue&type=template&id=c08b0960&scoped=true&"
import script from "./HtmlBlockView.vue?vue&type=script&lang=js&"
export * from "./HtmlBlockView.vue?vue&type=script&lang=js&"
import style0 from "./HtmlBlockView.vue?vue&type=style&index=0&id=c08b0960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b0960",
  null
  
)

export default component.exports